<template lang="pug">
  v-container(fluid=true class="grey lighten-5 ma-0 pa-0")
    div(class="text-center")
      Heading(:title="$t('resetPassword.TITLE')")
      v-flex(class="xs12 sm6 offset-sm3")

        ValidationObserver(ref="form" v-slot="{ validate, dirty }")
          form(@submit.prevent="onSubmit")
            v-layout(column)

              v-flex(v-show="showChangePasswordInputs")
                ValidationProvider(name="password" rules="required")
                  div(slot-scope="{ errors }")
                    v-text-field(outlined background-color="white" id="password" name="password" type="password" ref="password" :label="$t('resetPassword.PASSWORD')" v-model="password" :data-vv-as="$t('resetPassword.PASSWORD')" autocomplete="off" dense)
                    p(class="red--text caption") {{ errors[0] }}

              v-flex(v-show="showChangePasswordInputs")
                ValidationProvider(name="confirmPassword" rules="required|confirmed:password")
                  div(slot-scope="{ errors }")
                    v-text-field(outlined id="confirmPassword" name="confirmPassword" type="password" :label="$t('resetPassword.CONFIRM_PASSWORD')" v-model="confirmPassword" :data-vv-as="$t('resetPassword.PASSWORD')" autocomplete="off")
                    p(class="red--text caption") {{ errors[0] }}

              v-flex(class="text-xs-center mt-5")
                v-btn(:to="{ name: 'login' }" small=true text=true) {{ $t('common.CANCEL') }}
                SubmitButton(@click="validate().then(submit)" :text="$t('resetPassword.CHANGE_PASSWORD')")

      ErrorMessage
      SuccessMessage
</template>

<script>
import router from '@/router'
import { mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver, localize, configure } from "vee-validate"

import pt_BR from "vee-validate/dist/locale/pt_BR.json";
import en from "vee-validate/dist/locale/en.json";
import es from "vee-validate/dist/locale/es.json";

export default {

  components: {
    ValidationProvider,
    ValidationObserver
  },

  data() {
    return {
      id: this.$route.params.id,
      password: '',
      confirmPassword: ''
    }
  },
  methods: {
    ...mapActions(['resetPassword']),
    async onSubmit() {
      const valid = await this.$refs.form.validate();
      if (valid) {
        await this.resetPassword({
          id: this.id,
          password: this.password
        })
      }
    }
  },
  computed: {
    showChangePasswordInputs() {
      return this.$store.state.resetPassword.showChangePasswordInputs
    }
  },
  created() {
    if (this.$store.state.auth.isTokenSet) {
      router.push({ name: 'home' })
    }
  }
}
</script>
